import { render, staticRenderFns } from "./footerbutton.vue?vue&type=template&id=8e732fca&scoped=true"
import script from "./footerbutton.vue?vue&type=script&lang=js"
export * from "./footerbutton.vue?vue&type=script&lang=js"
import style0 from "./footerbutton.vue?vue&type=style&index=0&id=8e732fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e732fca",
  null
  
)

export default component.exports